<template>
<div class="chapter">
<div class="inner_page">
<p class="bk-title"><span>The Silent Salesman</span></p>
<p class="bk-title1"><span>An Albert Samson Mystery</span></p>
<p class="authorname"><span>Michael Z. Lewin</span></p>
<p class="publisher"><span><img alt="image" class="svg" src="images/fig_01.jpg"/></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?8d6bc76c